import React from 'react';
import { motion } from 'framer-motion';

const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionButton = null,
  className = "",
  size = "medium" // small, medium, large
}) => {
  const getSizeClasses = (sizeType) => {
    const sizeMap = {
      small: {
        container: 'py-6',
        icon: 'w-12 h-12',
        title: 'text-lg',
        description: 'text-sm'
      },
      medium: {
        container: 'py-8',
        icon: 'w-16 h-16',
        title: 'text-xl',
        description: 'text-base'
      },
      large: {
        container: 'py-12',
        icon: 'w-20 h-20',
        title: 'text-2xl',
        description: 'text-lg'
      }
    };
    return sizeMap[sizeType] || sizeMap.medium;
  };

  const sizeClasses = getSizeClasses(size);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`text-center ${sizeClasses.container} ${className}`}
    >
      {Icon && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ 
            type: "spring",
            stiffness: 260,
            damping: 20,
            delay: 0.1 
          }}
          className="flex justify-center mb-4"
        >
          <Icon className={`${sizeClasses.icon} text-gray-400`} />
        </motion.div>
      )}
      
      {title && (
        <motion.h3
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className={`${sizeClasses.title} font-semibold text-gray-900 mb-2`}
        >
          {title}
        </motion.h3>
      )}
      
      {description && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className={`${sizeClasses.description} text-gray-600 mb-4 max-w-md mx-auto`}
        >
          {description}
        </motion.p>
      )}
      
      {actionButton && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {actionButton}
        </motion.div>
      )}
    </motion.div>
  );
};

export default EmptyState;